const createThemeStyle = (series) => {
    return (indexProvided) => {
        if (!series.length) {
            return {};
        }
        const index = Math.round(indexProvided);
        return series[index] || series[series.length - 1];
    };
};
export { createThemeStyle };
